type MediaDevicesWithSelectAudioOutput = MediaDevices & {
  selectAudioOutput?: (options?: { deviceId?: string }) => Promise<MediaDeviceInfo>
}

export const canUseSelectAudioOutput = (): boolean => {
  if (typeof navigator === 'undefined' || !navigator.mediaDevices) {
    return false
  }

  return typeof (navigator.mediaDevices as MediaDevicesWithSelectAudioOutput).selectAudioOutput === 'function'
}

/**
 * Firefox (and Chromium with speaker permission) expose audio outputs via an explicit picker.
 * After success, enumerateDevices includes the chosen device for setSinkId.
 */
export const selectAudioOutputDevice = async (): Promise<MediaDeviceInfo | null> => {
  const mediaDevices = navigator.mediaDevices as MediaDevicesWithSelectAudioOutput
  if (typeof mediaDevices.selectAudioOutput !== 'function') {
    return null
  }

  try {
    return await mediaDevices.selectAudioOutput()
  } catch (error) {
    // User cancelled the picker — not an application error
    if (error instanceof DOMException && (error.name === 'NotAllowedError' || error.name === 'AbortError')) {
      return null
    }
    throw error
  }
}
